import { useNavigate } from 'react-router-dom';
import { Star } from 'lucide-react';

export function EmptyFavorites() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-white px-8 py-16 text-center dark:border-slate-600 dark:bg-slate-800">
      <Star className="mb-4 h-14 w-14 text-slate-300 dark:text-slate-600" strokeWidth={1.25} />
      <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-100">Aucun favori pour le moment</h2>
      <p className="mt-2 max-w-md text-sm text-slate-600 dark:text-slate-400">
        Ajoutez des applications à votre tableau de bord depuis la vue « Toutes les apps » en cliquant sur
        l’étoile.
      </p>
      <button
        type="button"
        onClick={() => navigate('/apps')}
        className="mt-6 rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-slate-800 dark:bg-brand-600 dark:hover:bg-brand-700"
      >
        Gérer mes favoris
      </button>
    </div>
  );
}
